module.exports = __webpack_public_path__ + "static/img/ic_launcher_web.c091e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_launcher_web.png
// module id = 6ZXO
// module chunks = 0